import { render, staticRenderFns } from "./zone-discount-breakdown.vue?vue&type=template&id=28ff4be7&"
import script from "./zone-discount-breakdown.vue?vue&type=script&lang=js&"
export * from "./zone-discount-breakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports